//import "@fancyapps/fancybox/dist/jquery.fancybox";
import "@fancyapps/fancybox/src/js/core";
import "@fancyapps/fancybox/src/js/media";
import "@fancyapps/fancybox/src/js/guestures";


import {AuwGallery} from "./AuwGallery";

if($('.auw-gallery').length) {
    $.each($('.auw-gallery'),function(i,e){
        new AuwGallery($(e));
    });

}
